import React from 'react';
import { Navigate, Route, Routes } from 'react-router';
import { NestedApiLocalizationProvider } from 'src/provider/LocalizationProviderConnector';
import BidList from './BidList/BidList';

export default function BidLifeCycleRoute() {
  return (
    <NestedApiLocalizationProvider
      preloadResources={['BidLifeCycle', 'Common', 'Pagination']}
    >
      <Routes>
        <Route element={<Navigate replace to="bid-list" />} path="" />
        <Route element={<BidList />} path="bid-list" />
      </Routes>
    </NestedApiLocalizationProvider>
  );
}
